import { hasValue } from "~/helpers/common-helpers";

const units = ["m2", "ft2"] as const;
type Unit = (typeof units)[number];

export const useTranslateUnit = () => {
  const translate = useTranslator();
  const filter = useFilter();

  const isUnit = (unit: Nullable<string>): unit is Unit => hasValue(unit) && units.includes(unit as Unit);
  return (unit: Nullable<string>) => (isUnit(unit) ? translate(`UNITS_${filter.uppercase(unit)}`) : unit ?? "");
};
